// import React from 'react';
//
// const LastNews = () => {
//     return (
//         <div className="card">
//             <h5>Last Added News Event</h5>
//             <div>
//                 <i><small>2 hours ago</small></i>
//                 <h5 className="my-1">হাম আবার বাড়ছে! যা জানা প্রয়োজন।</h5>
//                 <p>হাম বা Measles বিশ্বজুড়ে আবারও বাড়তে শুরু করেছে। সাম্প্রতিক বৈশ্বিক স্বাস্থ্য তথ্য অনুযায়ী, ২০২3 সালে প্রায় ১ কোটি ৩ লাখ (10.3 million) মানুষ হামে আক্রান্ত হয়</p>
//             </div>
//             <hr/>
//             <div>
//                 <i><small>2 hours ago</small></i>
//                 <h5 className="my-1">হাম আবার বাড়ছে! যা জানা প্রয়োজন।</h5>
//                 <p>হাম বা Measles বিশ্বজুড়ে আবারও বাড়তে শুরু করেছে। সাম্প্রতিক বৈশ্বিক স্বাস্থ্য তথ্য অনুযায়ী, ২০২3 সালে প্রায় ১ কোটি ৩ লাখ (10.3 million) মানুষ হামে আক্রান্ত হয়</p>
//             </div>
//             <hr/>
//             <div>
//                 <i><small>2 hours ago</small></i>
//                 <h5 className="my-1">হাম আবার বাড়ছে! যা জানা প্রয়োজন।</h5>
//                 <p>হাম বা Measles বিশ্বজুড়ে আবারও বাড়তে শুরু করেছে। সাম্প্রতিক বৈশ্বিক স্বাস্থ্য তথ্য অনুযায়ী, ২০২3 সালে প্রায় ১ কোটি ৩ লাখ (10.3 million) মানুষ হামে আক্রান্ত হয়</p>
//             </div>
//         </div>
//     );
// };
//
// export default LastNews;
import React from "react";
import moment from "moment";
import {Avatar} from "primereact/avatar";
import {webInfo} from "../../utils/webInfo";

const stripHtml = (html: string = "") => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
};

const truncateText = (text: string = "", maxLength: number = 140) => {
    if (text.length <= maxLength) return text;
    return text.slice(0, maxLength) + "...";
};

const LastNews = ({ data = [], loading = false }: any) => {
    return (
        <div className="card h-full">
            <h5>Last Added News Event</h5>

            {loading ? (
                <p>Loading...</p>
            ) : data.length === 0 ? (
                <p>No news found.</p>
            ) : (
                data?.map((item: any, index: number) => (
                    <div key={item.id || index} className={'relative'}>
                        <div>
                            <div className="grid">
                                <div className="col-2">
                                    <Avatar image={`${webInfo.baseUrl}/${item?.image}`} size="large" shape="square" />
                                </div>
                                <div className="col-10">
                                    <h5 className="m-0">{item.title}</h5>
                                    <small>{moment(item.created_at).fromNow()}</small>
                                </div>
                            </div>

                            <p className="m-0 mt-1">
                                {truncateText(stripHtml(item.content), 130)}
                            </p>
                        </div>

                        {index !== data.length - 1 && <hr />}
                    </div>
                ))
            )}
        </div>
    );
};

export default LastNews;